var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-dashboard-card',{attrs:{"title":"평가 매트릭스","id":"esg-partner-evaluation-matrix"}},[_c('div',{staticClass:"my-3"},[_c('apex-chart',{attrs:{"type":"radar","width":"450","options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }